module.exports = __webpack_public_path__ + "static/media/Twitch.5ec55b03.png";